/**
 * @file: OutcomeList.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The channel's outcomes as a rounded list card; tapping a row toggles it,
 * the active row gets brand ink and a check.
 */

import { Typography } from '@euler/app/components/typography';
import { LD } from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  LeadActivityOutcome,
  LeadActivityOutcomeLabel,
} from '@euler/model/lead/LeadActivity';
import { Check } from 'lucide-react-native';
import { TouchableOpacity } from 'react-native';
import { Card } from './common/Card';

export const OutcomeList = ({
  outcomes,
  outcome,
  onToggle,
}: {
  outcomes: LeadActivityOutcome[];
  outcome: LeadActivityOutcome | undefined;
  onToggle: (o: LeadActivityOutcome) => void;
}) => {
  const { rpx } = useResponsiveContext();
  return (
    <Card>
      {outcomes.map((o, index) => {
        const active = o === outcome;
        return (
          <TouchableOpacity
            key={o}
            activeOpacity={0.6}
            onPress={() => onToggle(o)}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              minHeight: rpx(48),
              paddingVertical: rpx(10),
              borderTopWidth: index === 0 ? 0 : 1,
              borderTopColor: LD.hairline,
            }}
          >
            <Typography.Text
              size={rpx(15)}
              color={active ? LD.brand : LD.ink}
              bold={active || undefined}
              style={{ flex: 1 }}
            >
              {LeadActivityOutcomeLabel[o]}
            </Typography.Text>
            {active ? <Check size={rpx(20)} color={LD.brand} /> : null}
          </TouchableOpacity>
        );
      })}
    </Card>
  );
};
